import React from "react";
import {useField} from "formik";
import styled from "styled-components";

const TextareaFormikInput = ({label, ...props}) => {
    const [field, meta] = useField(props);
    return (
        <>
            <Textarea className="text-area" {...field} {...props} />
            {meta.touched && meta.error ? (
                <div className="error">{meta.error}</div>
            ) : null}
        </>
    );
}

const Textarea = styled.textarea`
    width: 100%;
`

export default TextareaFormikInput